module.exports = BrowseNoDealsErrorPresenter =
  toHash: (lastUpdatedRefinementId)->
    switch lastUpdatedRefinementId
      when 'range' then {
        noDealsMessage: I18n.translate 'js.modules.browse.presenters.no_deals_discoverability.range.message'
        noDealsSuggestion: I18n.translate 'js.modules.browse.presenters.no_deals_discoverability.range.suggestion'
      }
      when 'discount' then {
        noDealsMessage: I18n.translate 'js.modules.browse.presenters.no_deals_discoverability.discount.message'
        noDealsSuggestion: I18n.translate 'js.modules.browse.presenters.no_deals_discoverability.discount.suggestion'
      }
